import { EMPTY_LIST } from '../../../../../constants/common'
import { useValidationWithoutFormikNotifications } from '../../../../../hooks'
import { getItemsIds } from '../../../../../utils/common'
import {
  useTableModalCloseHandler,
  useTableModalLoadingData,
} from '../../../../TableModal'
import { getAttachedTasks } from '../../AttachTasksModal.api'
import {
  ATTACH_TASKS_ORDERING,
  ATTACH_TASKS_PAGINATION_PAGE_SIZE_KEY,
} from '../../AttachTasksModal.constants'
import {
  getAttachTasksFromResponse,
  getAttachTasksModalTableColumns,
  isEqualAttachTasksModal,
} from '../../AttachTasksModal.utils'

export function useAttachTasksModal({
  getItemsFromResponse = getAttachTasksFromResponse,
  initialSelection = EMPTY_LIST,
  pipelineId,
  onAttach,
  onClose,
}) {
  function loadItems(id, params) {
    return getAttachedTasks({
      ...params,
      ...(pipelineId ? { pipeline: pipelineId } : null),
      ordering: params.ordering ?? ATTACH_TASKS_ORDERING,
    })
  }

  const loadData = useTableModalLoadingData({
    getItemsFromResponse,
    initialSelection,
    loadItems,
    paginationPageSizeKey: ATTACH_TASKS_PAGINATION_PAGE_SIZE_KEY,
  })

  const {
    handlePrependNotification,
    handleRemoveNotification,
    initialSelectionValues,
    selected,
    setLoading,
  } = loadData

  const { handleCloseTableModal, isCloseConfirm, setCloseConfirm } =
    useTableModalCloseHandler({
      initialSelectionValues,
      selected,
      onClose,
    })

  const { isValidForm, setNotificationListRef } =
    useValidationWithoutFormikNotifications({
      validationSchemaProps: {
        isEqual: isEqualAttachTasksModal,
        isEqualProps: { initialSelection, selected },
      },
      onRemoveNotification: handleRemoveNotification,
      onSetNotification: handlePrependNotification,
    })

  function handleAttach() {
    if (isValidForm()) {
      setLoading(true)

      onAttach(getItemsIds(selected)).finally(() => setLoading(false))
    }
  }

  const tableColumns = getAttachTasksModalTableColumns()

  return {
    handleAttach,
    handleCloseTableModal,
    isCloseConfirm,
    loadData,
    setCloseConfirm,
    setNotificationListRef,
    tableColumns,
  }
}
